
// State Object for ReleasesCatalog. Dont directly mutate it anywhere except the releases/mutations.js file
export const releasesCatalogState = {
  releasesCatalogData: null,
  releaseCatalogMetaData:null,
  releasesList: null,
  releaseDetails:null
}


